"use client"
import Close from "@/components/images/Close";
import type ArrayElement from "@/lib/ArrayElement";
import buildDocumentUrl from "@/lib/buildDocumentUrl";
import useClickOutside from "@/lib/useClickOutside";
import { type SettingsQueryResult } from "@/sanity/sanity.types";
import classNames from "classnames";
import Link from "next/link";
import { type Dispatch, type SetStateAction, useState } from "react";
import styles from "./DropDownMenu.module.css";

type DropDownMenuType = NonNullable<NonNullable<SettingsQueryResult>["dropDownMenu"]>;
/*

*/

//#region [Props]
type DropdownMenuProps = {
    dropDownMenu: DropDownMenuType | null | undefined;
    className?: string;
};
//#endregion

//#region [Component]
export default function DropdownMenu({ dropDownMenu, className }: DropdownMenuProps) {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useClickOutside<HTMLDivElement>(() => setIsOpen(false));

    return <div className={classNames(styles.DropDownMenu, className)} ref={ref}>
        <button aria-label="Vis menyen" className={styles.DropDownMenu_Button} onClick={() => setIsOpen(true)}><span className={styles.ButtonSpacer}></span>Meny</button>

        <div className={classNames(styles.DropDownMenu_Links, isOpen ? styles.Open : undefined)}>
            <button onClick={() => setIsOpen(false)} aria-label="Lukk menyen" className={styles.Close_Button}>
                <Close theme="dark"/>
            </button>
            <nav>
                {dropDownMenu?.map(m => buildLink(m, setIsOpen, m._key))}
            </nav>
        </div>
    </div>;
}
//#endregion

type DropDownElementType = ArrayElement<DropDownMenuType>;

function buildLink(target: DropDownElementType, setIsOpen: Dispatch<SetStateAction<boolean>> , key?: string, ) {
    switch (target._type) {
        case "intLink":
            return <Link onClick={() => setIsOpen(false)} href={target.page!} key={key} className={styles.Link}>{target.title}</Link>
        case "newsRef":
            if (!target.newsRefArticle) return null;
            return <Link onClick={() => setIsOpen(false)} href={buildDocumentUrl(target.newsRefArticle.slug!, target.newsRefArticle?._type)!} key={key} className={styles.Link}>{target.newsRefArticle.title}</Link>
    }
}